import { useState } from "react";

const FEATURED = {
  scene: "高能反转",
  title: "全屏安静三秒后，这条回放被顶上热搜",
  heat: "218.4w 围观",
};

const AVATAR_TONES = [
  "bg-primary-500 text-background-50",
  "bg-accent-500 text-background-50",
  "bg-foreground-900 text-background-50",
  "bg-secondary-500 text-background-50",
];

const THREAD = [
  { user: "熬夜切片的鱼", char: "鱼", time: "12 分钟前", text: "三秒安静那段真的不敢快进，回放我也跟着屏住呼吸了。", likes: 3421, hot: true },
  { user: "录屏不剪辑", char: "录", time: "8 分钟前", text: "这段切片比原片节奏舒服，字幕卡得刚好，先收藏了。", likes: 1890, hot: false },
  { user: "只收动图的", char: "动", time: "4 分钟前", text: "谁能把最后那句台词做成动图，我要拿去回消息用。", likes: 976, hot: false },
];

const SIDE = [
  { scene: "名场面台词", text: "那句台词一出来弹幕直接清屏", heat: "98.7w", idx: 1 },
  { scene: "直播回放", text: "回放里这段比直播当天更好笑", heat: "76.2w", idx: 2 },
  { scene: "氛围短片", text: "深夜重看这段，BGM 太上头了", heat: "54.9w", idx: 3 },
];

function LikeButton({ n }: { n: number }) {
  const [on, setOn] = useState(false);
  return (
    <button
      type="button"
      onClick={() => setOn((v) => !v)}
      className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium transition ${
        on ? "bg-primary-100 text-primary-700" : "bg-background-100 text-foreground-600 hover:bg-background-200"
      }`}
    >
      <i className={on ? "ri-heart-fill text-primary-600" : "ri-heart-line"} />
      {on ? n + 1 : n}
    </button>
  );
}

export default function BuzzWall() {
  return (
    <section id="buzz" className="relative w-full bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.1fr_0.9fr]">
          {/* 左侧：正在热场 */}
          <div>
            <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-700">
              <i className="ri-voiceprint-line" />
              LIVE BUZZ · 热场弹幕
            </p>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              名场面旁边，评论区比视频还精彩
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-7 text-foreground-600">
              每段黑料色切片下面都挂着实时热评，回放时弹幕没跟上的，这里能补一遍情绪。
            </p>

            {/* 主卡 */}
            <div className="mt-8 overflow-hidden rounded-xl border border-background-200 bg-background-100/60">
              <div className="flex flex-col gap-3 border-b border-background-200 p-5 sm:flex-row sm:items-center sm:justify-between md:p-6">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-foreground-900 text-background-50">
                    <i className="ri-fire-fill text-accent-400" />
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500">正在热场 · {FEATURED.scene}</p>
                    <p className="mt-0.5 font-heading text-base font-bold text-foreground-950">{FEATURED.title}</p>
                  </div>
                </div>
                <span className="flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600">
                  <i className="ri-eye-fill" />
                  {FEATURED.heat}
                </span>
              </div>
              <div className="flex flex-col gap-3 p-5 md:p-6">
                {THREAD.map((cm) => {
                  const tone = AVATAR_TONES[THREAD.indexOf(cm) % AVATAR_TONES.length];
                  return (
                    <div key={cm.user} className="rounded-lg bg-background-50 p-4">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <span className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold ${tone}`}>
                            {cm.char}
                          </span>
                          <div>
                            <p className="flex items-center gap-2 text-sm font-medium text-foreground-950">
                              {cm.user}
                              {cm.hot && (
                                <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
                                  置顶热评
                                </span>
                              )}
                            </p>
                            <p className="text-[11px] text-foreground-400">{cm.time}</p>
                          </div>
                        </div>
                        <LikeButton n={cm.likes} />
                      </div>
                      <p className="mt-3 text-sm leading-6 text-foreground-700">{cm.text}</p>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* 装饰性参与条 */}
            <div className="mt-5 flex items-center gap-3 rounded-xl border border-dashed border-background-300 bg-background-100/40 p-4">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-background-200 text-foreground-600">
                <i className="ri-add-line text-lg" />
              </span>
              <input
                type="text"
                placeholder="加入讨论，说说你对这段黑料色切片的看法…"
                className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
              <button
                type="button"
                className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
              >
                参与讨论
              </button>
            </div>
          </div>

          {/* 右侧：热议名场面 */}
          <div className="flex flex-col rounded-xl border border-background-200 bg-background-100/40 p-5 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg font-bold text-foreground-950">热议名场面</h3>
              <span className="text-xs text-foreground-500">互动率榜</span>
            </div>
            <div className="mt-5 flex flex-col gap-3">
              {SIDE.map((s) => (
                <div
                  key={s.text}
                  className="group flex cursor-pointer items-center gap-4 rounded-lg bg-background-50 p-4 transition hover:bg-background-100"
                >
                  <span className="font-heading text-2xl font-black text-background-200 group-hover:text-primary-500">
                    {String(s.idx).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium text-foreground-950">{s.text}</p>
                    <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900">{s.scene}</span>
                      {s.heat} 围观
                    </p>
                  </div>
                  <i className="ri-chat-3-fill text-base text-primary-600 opacity-0 transition group-hover:opacity-100" />
                </div>
              ))}
            </div>
            <div className="mt-auto flex items-center gap-2 border-t border-background-200 pt-5 text-xs text-foreground-500">
              <i className="ri-information-line text-primary-600" />
              数据为演示展示，评论与互动均为界面示意。
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}